import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Context token to mark HTTP requests as external (e.g., S3 signed URLs)
 * When set to true, interceptors should skip adding authentication headers
 * and query parameters to preserve signed URL integrity
 */
export const IS_EXTERNAL_REQUEST = new HttpContextToken<boolean>(() => false);

/**
 * Helper function to create an HttpContext with the external request flag set
 */
export function createExternalRequestContext(): HttpContext {
    return new HttpContext().set(IS_EXTERNAL_REQUEST, true);
}

